import { Layout } from 'components/Layout/Layout';
import CMSPage from 'components/PageWrapper/PageWrapper';
import withApollo from 'lib/apollo';
import { useUnauthenticatedOnlyRoute } from 'lib/hooks/useUnauthenticatedOnlyRoute';
import * as React from 'react';
import { PublicCMSLayout } from '../components/Layout/PublicCMSLayout';

function GetHelpPage() {
  return (
    <Layout classNames={['h-background--navy-200']} title="Get help">
      <PublicCMSLayout>
        <CMSPage title="Get help" pageUrl="get-help" />
      </PublicCMSLayout>
    </Layout>
  );
}

export default withApollo(GetHelpPage, { useTemporaryToken: true });
